<template>
  <base-form
    id="edit-profile"
    method="post"
    :schema="editProfileSchema"
    :handleSubmit="handleSubmit"
  >
    <div class="avatar">
      <div class="avatar-image-wrapper" @click="uploadProfileAvatar()">
        <div class="change-photo-hover">
          <div class="change-photo-wrapper">
            <input
              id="edit-profile-avatar"
              type="file"
              accept="image/*,image/heif,image/heic"
              class="display-none"
              ref="avatarInput"
              @change="avatarUploaded()"
            />
            <img src="@/Common/Icons/Edit.png" alt="Edit" />
            <p>Change photo</p>
          </div>
        </div>
        <app-loader v-show="spinner" :isGreen="true"></app-loader>
        <img
          ref="avatarImageSrc"
          :src="avatarImage()"
          alt="Avatar"
          v-show="!spinner"
        />
      </div>
    </div>
    <div class="wallet-address">
      <p class="address">{{ shortenedWalletAddress() }}</p>
      <div class="copy-address" @click="copyToClipboard(walletAddress)">
        <div class="copy-hover">Copy address</div>
        <img src="@/Common/Icons/Copy.png" alt="Copy" />
      </div>
    </div>
    <div class="edit-profile-name">
      <app-input
        id="edit-name"
        v-model="userToUpdate.displayName"
        :value="userToUpdate.displayName"
        placeholder="Enter your display name"
        inputClass="app-modal-input"
        type="text"
        labelText="Display name"
        labelClass="label"
        name="displayName"
        componentClass="section-inputs"
      />
    </div>
    <div class="edit-profile-description">
      <app-textarea
        id="edit-description"
        type="text"
        v-model="userToUpdate.description"
        :value="userToUpdate.description"
        labelText="Bio"
        labelClass="label"
        name="description"
        textAreaClass="form-box-textarea"
        componentClass="section-inputs"
        cols="1"
        rows="4"
        placeholder="Tell us about yourself in a few words"
      />
      <span class="description-num-chars"
        >{{ userToUpdate.description.length }}/200
      </span>
    </div>
    <div class="edit-profile-email">
      <app-input
        id="edit-email"
        v-model="userToUpdate.email"
        :value="userToUpdate.email"
        placeholder="your@email.com"
        inputClass="app-modal-input"
        type="text"
        labelText="E-mail"
        labelClass="label"
        name="email"
        componentClass="section-inputs"
      />
    </div>
    <div class="social-website">
      <div class="edit-twitter">
        <app-input
          id="edit-twitter"
          v-model="userToUpdate.twitterUsername"
          :value="userToUpdate.twitterUsername"
          placeholder="@"
          inputClass="app-modal-input"
          type="text"
          labelText="Twitter username"
          labelClass="label"
          name="twitterUsername"
          componentClass="section-inputs"
        />
      </div>
      <div class="edit-website">
        <app-input
          id="edit-website"
          v-model="userToUpdate.websiteUrl"
          :value="userToUpdate.websiteUrl"
          placeholder="https://"
          inputClass="app-modal-input"
          type="text"
          labelText="Personal site or portfolio"
          labelClass="label"
          name="websiteUrl"
          componentClass="section-inputs"
        />
      </div>
    </div>
    <div class="app-modal-button-controls">
      <app-button
        text="Back to profile"
        buttonClass="app-modal-button"
        @click.prevent="historyBack()"
      ></app-button>
      <app-button
        text="Save changes"
        type="submit"
        buttonClass="app-modal-button-inverse-old"
        :buttonStyle="updateProfileButtonStyle()"
      ></app-button>
    </div>
  </base-form>
</template>

<script>
import BaseForm from "@/components/BaseForm";
import AppInput from "@/elements/AppInput";
import AppTextarea from "@/elements/AppTextarea";
import AppButton from "@/elements/AppButton";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import useUserProfile from "@/composables/useUserProfile";
import useUtilities from "@/composables/useUtilities";
import { editProfileSchema } from "@/validationSchemas/editProfileSchema";
import AppLoader from "@/elements/AppLoader";
export default {
  components: {
    BaseForm,
    AppInput,
    AppTextarea,
    AppButton,
    AppLoader,
  },
  setup() {
    const store = useStore();
    const router = useRouter();
    const {
      userToUpdate,
      avatarImage,
      handleSubmit,
      walletAddress,
      commitToStore,
      shortenedWalletAddress,
      spinner,
      avatarInput,
      avatarImageSrc,
      uploadProfileAvatar,
      avatarUploaded,
    } = useUserProfile(store, router);

    const updateProfileButtonStyle = () => ({
      "max-width": "250px",
      margin: "0 auto",
    });

    const historyBack = () => history.back();

    const { copyToClipboard } = useUtilities();
    return {
      userToUpdate,
      handleSubmit,
      avatarImage,
      shortenedWalletAddress,
      updateProfileButtonStyle,
      walletAddress,
      copyToClipboard,
      commitToStore,
      editProfileSchema,
      uploadProfileAvatar,
      avatarUploaded,
      avatarInput,
      avatarImageSrc,
      spinner,
      historyBack,
    };
  },
};
</script>

<style lang="scss" scoped src="@/Common/Styles/editProfileForm.scss"></style>
